// extracted by mini-css-extract-plugin
module.exports = {"preloadWrapper":"preloader_preloadWrapper__UMpMl","video":"preloader_video__6YBPw"};